import { render } from "./YotpoIntegrationCenter.vue?vue&type=template&id=6b547816&scoped=true"
import script from "./YotpoIntegrationCenter.vue?vue&type=script&lang=js"
export * from "./YotpoIntegrationCenter.vue?vue&type=script&lang=js"

import "./YotpoIntegrationCenter.vue?vue&type=style&index=0&id=6b547816&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b547816"]])

export default __exports__